import React from "react";
import { BrowserRouter } from "react-router-dom";
import QueryProvider from "app/providers/QueryProvider";
import AuthProvider from "app/providers/AuthProvider";
import ToastProvider from "app/providers/ToastProvider";

type AppProvidersProps = {
  children: React.ReactNode;
};

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <BrowserRouter>
      <QueryProvider>
        <AuthProvider>
          <ToastProvider>{children}</ToastProvider>
        </AuthProvider>
      </QueryProvider>
    </BrowserRouter>
  );
};

export default AppProviders;
